import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/landing';
const ease = [0.23, 1, 0.32, 1] as const;
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);

  // Split into two columns; numbering stays continuous (01–04 left, 05–08 right)
  const half = Math.ceil(faqs.length / 2);
  const columns = [faqs.slice(0, half), faqs.slice(half)];
  return <section id="faq" aria-labelledby="faq-heading" className="px-page pb-20 md:pb-28" data-id="element-106" data-mp="2dy3j3njdo3td">
      <div className="w-full" data-id="element-107" data-mp="28za2hm8snwoz">
        <h2 id="faq-heading" className="sr-only" data-id="element-108" data-mp="241qrcv7e8019">
          Questions
        </h2>

        {/* Serif lead, matching the page's statements */}
        <p className="mx-auto text-center font-serif text-[36px] font-normal leading-[1.08] tracking-[-0.01em] text-fg md:text-[48px]" data-id="element-109" data-mp="1z2nj71w49dp2">
          Questions investors and founders ask, answered <span className="text-fg/40" data-id="element-110" data-mp="nmz0wntt52ul">before</span> we begin.
        </p>

        <div className="mt-10 grid gap-x-8 md:mx-auto md:mt-12 md:grid-cols-2 lg:w-[72%] lg:min-w-[760px] md:items-start" data-id="element-111" data-mp="phekk6mrdjhg">
          {columns.map((col, c) => <ul key={c} className={`border-t border-line ${c === 1 ? 'border-t-0 md:border-t' : ''}`} data-id="element-112" data-mp="uey5fpdyouid" data-mpi={c}>
              {col.map((faq, j) => {
            const i = c * half + j;
            const isOpen = open === i;
            const panelId = `faq-panel-${i}`;
            return <li key={faq.question} className="border-b border-line" data-id="element-113" data-mp="6pdfgmje4wzl" data-mpi={j}>
                    <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={panelId} className="group flex w-full items-center justify-between gap-5 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-fg md:py-6" data-id="element-114" data-mp="bjpwyr1b3y8p">
                      <span className="flex items-baseline gap-5 md:gap-6" data-id="element-115" data-mp="3o1o55z2izw9r">
                        <span className="w-8 shrink-0 text-[12px] font-medium tabular-nums tracking-[0.04em] text-muted" data-id="element-116" data-mp="1uifh7lyrpuof">
                          {String(i + 1).padStart(2, '0')}
                        </span>
                        <span className={`text-[17px] font-normal leading-[1.3] tracking-[-0.015em] transition-colors duration-150 md:text-[19px] ${isOpen ? 'text-fg' : 'text-fg/45 group-hover:text-fg'}`} data-id="element-117" data-mp="1krb3sqoqqhvp">
                          {faq.question}
                        </span>
                      </span>
                      <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-control border transition-colors duration-150 ${isOpen ? 'border-black bg-black text-white' : 'border-fg/80 text-fg group-hover:border-black group-hover:bg-black group-hover:text-white'}`} aria-hidden="true" data-id="element-118" data-mp="23jm021ow3hku">
                        <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] ${isOpen ? 'rotate-45' : ''}`} data-id="element-119" data-mp="33pz7th1zgwcp" />
                      </span>
                    </button>
                    <AnimatePresence initial={false} data-id="element-120" data-mp="3igybcdnyoupf">
                      {isOpen && <motion.div id={panelId} key="panel" initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.25,
                  ease
                }} className="overflow-hidden" data-id="element-121" data-mp="3nft3453wptlo">
                          <p className="max-w-[520px] pb-6 pl-[52px] pr-14 text-[15px] leading-[1.55] text-fg/60" data-id="element-122" data-mp="16pe3spzu0u9q">
                            {faq.answer}
                          </p>
                        </motion.div>}
                    </AnimatePresence>
                  </li>;
          })}
            </ul>)}
        </div>
      </div>
    </section>;
}